/** Sample values for lead notification template preview. */
export const LEAD_NOTIFY_PREVIEW_SAMPLES = {
  recipient_name: "Sales Team",
  opportunity_name: "Enterprise Outreach Q3",
  contact_name: "Jane Smith",
  company: "Acme Corporation",
  signal_source: "RNC",
  qualification_date: "2026-08-03 10:30 UTC",
  assigned_owner: "Alex Morgan <alex@company.com>",
  notes: "Strong buying intent — requested pricing details.",
  opportunity_link: "https://app.sellyx.ai/outreach/campaigns/sample-campaign",
  communication_channel: "email",
  contact_address: "jane.smith@acme.com",
};

/** Render {{placeholder}} tokens for preview. */
export function previewLeadNotificationTemplate(html, samples = LEAD_NOTIFY_PREVIEW_SAMPLES) {
  let out = html || "";
  Object.entries(samples).forEach(([key, value]) => {
    out = out.replaceAll(`{{${key}}}`, value || "");
  });
  out = out.replace(/\{\{\s*[\w.]+\s*\}\}/g, "");
  return out;
}

/** Ten rotating auto-generated lead notification templates (HTML). */
export const LEAD_NOTIFICATION_AUTO_TEMPLATES = [
  `<p>Hi <strong>{{recipient_name}}</strong>,</p>
<p>A new opportunity has been marked <strong>Qualified</strong> in Sellyx and may require your attention.</p>
<ul>
<li><strong>Opportunity:</strong> {{opportunity_name}}</li>
<li><strong>Contact:</strong> {{contact_name}}</li>
<li><strong>Company:</strong> {{company}}</li>
<li><strong>Signal Source:</strong> {{signal_source}}</li>
<li><strong>Qualified on:</strong> {{qualification_date}}</li>
<li><strong>Owner:</strong> {{assigned_owner}}</li>
</ul>
<p><strong>Notes:</strong> {{notes}}</p>
<p><a href="{{opportunity_link}}">View opportunity in Sellyx</a></p>
<p>— Sellyx</p>`,

  `<p>Dear {{recipient_name}},</p>
<p>We have a newly qualified lead ready for follow-up.</p>
<p><strong>{{contact_name}}</strong> at <strong>{{company}}</strong> has reached Qualified status on <em>{{opportunity_name}}</em>.</p>
<p>Source: {{signal_source}} · Owner: {{assigned_owner}} · Date: {{qualification_date}}</p>
<p>{{notes}}</p>
<p><a href="{{opportunity_link}}">Open in Sellyx</a></p>`,

  `<p>Hello {{recipient_name}},</p>
<p><strong>Qualified lead alert</strong> — please review the details below:</p>
<ol>
<li>Opportunity: {{opportunity_name}}</li>
<li>Contact: {{contact_name}} ({{contact_address}})</li>
<li>Company: {{company}}</li>
<li>Channel: {{communication_channel}}</li>
<li>Signal: {{signal_source}}</li>
<li>Qualified: {{qualification_date}}</li>
</ol>
<p>Assigned owner: {{assigned_owner}}</p>
<p>Notes: {{notes}}</p>
<p><a href="{{opportunity_link}}">View opportunity</a></p>`,

  `<p>Hi {{recipient_name}},</p>
<p>A prospect on <strong>{{opportunity_name}}</strong> is now qualified.</p>
<p><u>Contact</u>: {{contact_name}}<br/>
<u>Company</u>: {{company}}<br/>
<u>Source</u>: {{signal_source}}<br/>
<u>Owner</u>: {{assigned_owner}}<br/>
<u>Date</u>: {{qualification_date}}</p>
<p><em>{{notes}}</em></p>
<p><a href="{{opportunity_link}}">Review in Sellyx →</a></p>`,

  `<p>{{recipient_name}},</p>
<p>Heads up — <strong>{{contact_name}}</strong> from <strong>{{company}}</strong> has been qualified.</p>
<p>Campaign: {{opportunity_name}}<br/>
Signal source: {{signal_source}}<br/>
Qualification date: {{qualification_date}}<br/>
Opportunity owner: {{assigned_owner}}</p>
<p>Additional context: {{notes}}</p>
<p><a href="{{opportunity_link}}">View details</a></p>
<p>Best,<br/>Sellyx</p>`,

  `<p>Hi {{recipient_name}},</p>
<p>A qualified opportunity is waiting in your queue.</p>
<blockquote>
<p><strong>{{contact_name}}</strong> · {{company}}<br/>
{{opportunity_name}} · {{signal_source}}<br/>
Qualified {{qualification_date}} by {{assigned_owner}}</p>
</blockquote>
<p>{{notes}}</p>
<p><a href="{{opportunity_link}}">Open opportunity</a></p>`,

  `<p>Dear {{recipient_name}},</p>
<p>Please prioritise outreach for the following qualified lead:</p>
<p><strong>Opportunity:</strong> {{opportunity_name}}<br/>
<strong>Contact:</strong> {{contact_name}}<br/>
<strong>Company:</strong> {{company}}<br/>
<strong>Email / address:</strong> {{contact_address}}<br/>
<strong>Channel:</strong> {{communication_channel}}<br/>
<strong>Signal:</strong> {{signal_source}}<br/>
<strong>Date:</strong> {{qualification_date}}<br/>
<strong>Owner:</strong> {{assigned_owner}}</p>
<p>Notes: {{notes}}</p>
<p><a href="{{opportunity_link}}">View in Sellyx</a></p>`,

  `<p>Hello {{recipient_name}},</p>
<p><strong>New qualified opportunity</strong></p>
<p>{{contact_name}} at {{company}} has been marked qualified on campaign <em>{{opportunity_name}}</em>.</p>
<ul>
<li>Signal source: {{signal_source}}</li>
<li>Qualification date: {{qualification_date}}</li>
<li>Assigned owner: {{assigned_owner}}</li>
<li>Contact: {{contact_address}}</li>
</ul>
<p>{{notes}}</p>
<p><a href="{{opportunity_link}}">Review opportunity</a></p>`,

  `<p>Hi {{recipient_name}},</p>
<p>Sellyx detected a qualified lead that matches your notification preferences.</p>
<p><strong>Summary</strong><br/>
Opportunity: {{opportunity_name}}<br/>
Contact: {{contact_name}}<br/>
Company: {{company}}<br/>
Source: {{signal_source}} · {{communication_channel}}<br/>
Qualified: {{qualification_date}}<br/>
Owner: {{assigned_owner}}</p>
<p><strong>Note:</strong> {{notes}}</p>
<p><a href="{{opportunity_link}}">View opportunity in Sellyx</a></p>`,

  `<p>{{recipient_name}},</p>
<p>A lead has progressed to <strong>Qualified</strong> status.</p>
<p>Take action on <strong>{{contact_name}}</strong> ({{company}}) from {{signal_source}}.</p>
<p>Campaign: {{opportunity_name}}<br/>
Qualified: {{qualification_date}}<br/>
Owner: {{assigned_owner}}<br/>
Contact address: {{contact_address}}</p>
<p>{{notes}}</p>
<p><a href="{{opportunity_link}}">Open in Sellyx</a></p>
<p>— Sellyx Notifications</p>`,
];

export function getAutoGeneratedLeadTemplate(index) {
  const i = ((index % LEAD_NOTIFICATION_AUTO_TEMPLATES.length) + LEAD_NOTIFICATION_AUTO_TEMPLATES.length)
    % LEAD_NOTIFICATION_AUTO_TEMPLATES.length;
  return LEAD_NOTIFICATION_AUTO_TEMPLATES[i];
}

export const LEAD_NOTIFY_PLACEHOLDER_HINTS = [
  "{{recipient_name}}",
  "{{opportunity_name}}",
  "{{contact_name}}",
  "{{company}}",
  "{{signal_source}}",
  "{{qualification_date}}",
  "{{assigned_owner}}",
  "{{notes}}",
  "{{opportunity_link}}",
  "{{communication_channel}}",
  "{{contact_address}}",
];
